import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FormControl,  ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ValidationErrorsComponent } from '../validation-errors/validation-errors.component';
import { PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';
import { OnlyNumbersPipe } from '../../../pipes/only-numbers.pipe';
import { TooltipModule } from 'primeng/tooltip';
@Component({
  selector: 'app-inline-input-control',
  standalone: true,
  imports: [ReactiveFormsModule, InputTextModule, ValidationErrorsComponent, PasswordModule, RippleModule, OnlyNumbersPipe,
    TooltipModule 
  ],
  templateUrl: './inline-input-control.component.html',
  styleUrl: './inline-input-control.component.scss'
})
export class InlineInputControlComponent {
  @Input() label!: string;
  @Input() placeholder!: string;
  @Input() control!: FormControl | any;
  @Input() name: string = '';
  @Input() type: 'text' | 'password' | 'email' | 'number'  = 'text';
  @Input() lightMode!: boolean;
  @Input() classess!: string;
  @Input() pattern!: string;
  @Input() minlength!: number;
  @Input() maxlength!: number;
  @Input() requiredLabelEnabled: boolean = false;
  @Input() optionalLabelEnabled: boolean = false;
  @Input() showKenitalaValidation: boolean = false;
  @Input() readonly: boolean = false;
  @Input() flagPrefix!: boolean;
  @Input() sendMessageIconSuffix!: boolean;

  @Input() tooltipText: string;

  @Input() editControlAction: boolean = false;
  @Input() disabled: boolean;

  @Input() onlyNumbersPipe: boolean;
  @Output() afterEditActionPressed: EventEmitter<any> = new EventEmitter<any>(); 

  public triggerEditAction(){
    this.afterEditActionPressed.emit();
  }
  

}
